import * as React from 'react'
import { People } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { PeopleTable } from './PeopleTable'
import { ViewMoreLink } from '../../common/ViewMoreLink'
import { INVESTOR_TOP_LIST_COUNT } from '../../../pages/investors/[shortname]'

type Props = {
  shortname: string
  people: {
    current: People
    past: People
  }
}

export const InvestorPeople: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle>人物</CardTitle>
      <PeopleTable title="現職" list={props.people.current} />
      <ViewMoreLink
        isHidden={props.people.current.length != INVESTOR_TOP_LIST_COUNT}
        href={`/investor/people?shortname=${props.shortname}`}
        as={`/investors/${props.shortname}/people`}
      />
    </>
  )
}
